/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentSummaryDto
 */
export interface DocumentSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummaryDto
     */
    mediaCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummaryDto
     */
    mediaCategoryName: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummaryDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummaryDto
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummaryDto
     */
    fileExtension: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentSummaryDto
     */
    fileSizeBytes: number;
}

export function DocumentSummaryDtoFromJSON(json: any): DocumentSummaryDto {
    return {
        'id': json['id'],
        'mediaCategoryId': json['mediaCategoryId'],
        'mediaCategoryName': json['mediaCategoryName'],
        'name': json['name'],
        'fileName': json['fileName'],
        'fileExtension': json['fileExtension'],
        'fileSizeBytes': json['fileSizeBytes'],
    };
}

export function DocumentSummaryDtoToJSON(value?: DocumentSummaryDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'mediaCategoryId': value.mediaCategoryId,
        'mediaCategoryName': value.mediaCategoryName,
        'name': value.name,
        'fileName': value.fileName,
        'fileExtension': value.fileExtension,
        'fileSizeBytes': value.fileSizeBytes,
    };
}


